import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-custom card-stretch mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body px-0" }
const _hoisted_3 = { class: "d-flex bg-light-primary card-rounded flex-grow-1" }
const _hoisted_4 = { class: "py-10 ps-7" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-relative bgi-no-repeat bgi-size-contain bgi-position-y-bottom bgi-position-x-end mt-6 flex-grow-1",
  style: {"background-image":"url('media/misc/illustration-1.png')"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "text-primary d-block mb-n1",
              innerHTML: _ctx.titleText
            }, null, 8, _hoisted_6),
            _createElementVNode("span", {
              class: "font-weight-light fs-1 text-gray-800",
              innerHTML: _ctx.subtitleText
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push(_ctx.href)),
            class: "btn btn-primary btn-sm fw-bolder fs-6 ps-4 mt-6"
          }, [
            _createTextVNode(_toDisplayString(_ctx.actionBtnLabelText) + " ", 1),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: _ctx.actionBtnImageSrc }, null, 8, ["src"])
            ])
          ])
        ]),
        _hoisted_9
      ])
    ])
  ]))
}